import classNames from "classnames";
import React, { PropsWithChildren } from "react";

interface InputWrapperProps {
  /** Use "large" for the sign up form and marketing site inputs and selects only */
  inputStyle?: "default" | "large";
  /** The default width is set to match the inputs size to its content.
   * Full width sets the input to have a width of 100% of its parent element. */
  inputWidth?: "default" | "full";
  /** Move input alignment to the right for displaying things like currency */
  alignment?: "left" | "right";
  /** Signify if input is disabled or not */
  disabled?: boolean;
  /** Is input error'd */
  error?: boolean;
  extraClasses?: string;
}

export const InputWrapper: React.FC<PropsWithChildren<InputWrapperProps>> = ({
  alignment,
  children,
  disabled,
  error,
  inputStyle,
  extraClasses,
  inputWidth,
}) => {
  const wrapperClasses = classNames("input-wrapper", {
    [`input-wrapper--${inputStyle}`]: inputStyle,
    [`input-wrapper--error`]: error,
    ["input-wrapper--disabled"]: disabled,
    [`input-wrapper--full-width`]: inputWidth === "full",
    [`${extraClasses}`]: extraClasses,
  });

  return (
    <div className={wrapperClasses} data-align={alignment}>
      {children}
    </div>
  );
};
